import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentStarFilledSize32Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={32} height={32} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M4 1.333v29.334h24V12c0-8-2.667-10.667-10.667-10.667zm8.441 17.129.775.323.323.774c1.048 2.516 1.572 3.774 2.461 3.774s1.413-1.258 2.462-3.774l.322-.775.775-.322c2.516-1.049 3.774-1.573 3.774-2.462s-1.258-1.413-3.774-2.461l-.774-.323-.323-.775C17.413 9.925 16.889 8.667 16 8.667s-1.413 1.258-2.461 3.774l-.323.775-.775.323C9.925 14.587 8.667 15.11 8.667 16s1.258 1.413 3.774 2.462"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentStarFilledSize32Glyph.displayName = 'DocumentStarFilledSize32Glyph';
